'use strict';
var OrderSummaryEvents = /** @class */ (function () {
    function OrderSummaryEvents() {
        'ngInject';
        this.orderSummaryGTMTrackingEvents = {
            purchase: {
                event: 'purchase',
                customerType: 'practitioner',
                practitionerId: '',
                platform: '',
                ecommerce: {
                    transaction_id: '',
                    affiliation: '',
                    value: '',
                    tax: '',
                    shipping: '',
                    currency: '',
                    coupons: [],
                    items: []
                }
            }
        };
    }
    return OrderSummaryEvents;
}());
export { OrderSummaryEvents };
//# sourceMappingURL=order-summary.events.js.map